import { useNavigate } from "react-router-dom";
import { Sparkles, ArrowRight, ShieldCheck, Zap, Database, Search, TrendingUp, Briefcase } from "lucide-react";

const SIDES = {
  candidate: {
    eyebrow: "Kariérny pas novej generácie",
    title: "Vytvor si svoj profesionálny profil",
    desc: <>Nahraj svoje staré CV a my z neho spravíme moderný <span className="font-semibold text-slate-800">Career Passport</span>. Bez písania, bez komplikácií.</>,
    features: [
      { icon: Zap, text: "Hotový profil za pár sekúnd" },
      { icon: ShieldCheck, text: "Zdieľaš iba link — žiadne posielanie CV" },
      { icon: Briefcase, text: "Objavuj nové pracovné príležitosti" },
    ],
    cta: "Vytvoriť profil", to: "/register?role=candidate",
    ctaId: "welcome-create-profile-btn", loginId: "welcome-login-btn",
  },
  company: {
    eyebrow: "Moderná databáza. Rýchlejší nábor",
    title: "Vybuduj si vlastnú databázu talentov",
    desc: "Maj svojich kandidátov pod kontrolou a vytvor si systém, ktorý ti pomôže obsadzovať pozície rýchlejšie.",
    features: [
      { icon: Database, title: "Vlastná databáza kandidátov", text: "Maj svoje talenty pod kontrolou" },
      { icon: Search, title: "Rýchlejšie vyhľadávanie talentov", text: "Nájdi vhodných kandidátov pre nové pozície" },
      { icon: TrendingUp, title: "Efektívnejší recruiting", text: "Pracuj systematicky a využívaj svoj talent pool" },
    ],
    cta: "Vytvoriť databázu", to: "/register?role=company",
    ctaId: "welcome-create-database-btn", loginId: "welcome-company-login-btn",
  },
};

export default function Welcome() {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="mx-auto w-full max-w-6xl flex-1 flex flex-col px-6 pt-16 pb-10">
        <div className="flex items-center gap-2 fade-up">
          <div className="h-10 w-10 rounded-xl bg-blue-700 flex items-center justify-center">
            <Sparkles className="text-white" size={20} />
          </div>
          <span className="font-head text-xl font-bold tracking-tight">Profeeluj</span>
        </div>
        <div className="flex-1 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 py-12">
          <Half side={SIDES.company} testId="welcome-company-half" className="order-2 lg:order-1" />
          <Half side={SIDES.candidate} testId="welcome-candidate-half" className="order-1 lg:order-2" />
        </div>
      </div>
    </div>
  );
}

function Half({ side, testId, className }) {
  const nav = useNavigate();
  return (
    <section data-testid={testId} className={`flex flex-col ${className}`}>
      <div className="flex-1 flex flex-col">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-blue-600 fade-up">{side.eyebrow}</p>
        <h1 className="mt-4 font-head text-4xl sm:text-5xl font-bold tracking-tight text-slate-900 leading-[1.1] fade-up">{side.title}</h1>
        <p className="mt-5 text-base leading-relaxed text-slate-600 fade-up">{side.desc}</p>
        <div className="mt-8 space-y-3">
          {side.features.map((f) => <Feature key={f.text} {...f} />)}
        </div>
      </div>
      <div className="mt-10 space-y-3">
        <button data-testid={side.ctaId} onClick={() => nav(side.to)}
          className="w-full flex items-center justify-center gap-2 bg-blue-700 text-white hover:bg-blue-800 rounded-full px-6 py-4 font-semibold transition-colors active:scale-95">
          {side.cta} <ArrowRight size={18} />
        </button>
        <button data-testid={side.loginId} onClick={() => nav("/login")}
          className="w-full bg-white text-slate-700 border border-slate-300 hover:bg-slate-50 rounded-full px-6 py-4 font-semibold transition-colors active:scale-95">
          Prihlásiť sa
        </button>
      </div>
    </section>
  );
}

function Feature({ icon: Icon, title, text }) {
  return (
    <div className="flex items-center gap-3 fade-up">
      <div className="h-9 w-9 rounded-xl bg-blue-50 flex items-center justify-center flex-shrink-0">
        <Icon size={18} className="text-blue-700" />
      </div>
      <span className="text-sm text-slate-700">
        {title ? <><span className="block font-semibold text-slate-800">{title}</span>{text}</> : <span className="font-medium">{text}</span>}
      </span>
    </div>
  );
}
